import React from 'react';
import Button from 'src/view/components/Controls/ButtonComponent/Button';
import { localeStore } from 'src/mobx/localesStore';
import './style.scss';

interface IProps {
  auth_route?: string;
}

const FoodicsAuthorizationForm: React.FC<IProps> = (props: IProps) => {
  const authorize = () => {
    if (!props.auth_route) {
      return;
    }
    window.location.href = props.auth_route;
  };
  return (
    <div className="foodics-authorization-form mt-6">
      <div className="foodics-authorization-form__title">{localeStore.t('t2_foodics_authorization')}</div>
      <div className="foodics-authorization-form__text mt-4">{localeStore.t('t2_foodics_text1')}</div>
      <a
        className="foodics-authorization-form__link mt-4 cursor-pointer"
        href="https://help.taker.io/portal/en/kb/articles/preparation-for-integration-with-foodics-f5"
        target="_blank"
      >
        {localeStore.t('t2_foodics_link1')}
      </a>
      <a
        className="foodics-authorization-form__link mt-4 cursor-pointer"
        href="https://help.taker.io/portal/en/kb/articles/integrating-with-foodics-f5"
        target="_blank"
      >
        {localeStore.t('t2_foodics_link2')}
      </a>
      <div className="foodics-authorization-form__text mt-6">{localeStore.t('t2_foodics_text2')}</div>
      <div className="mt-auto d-flex align-items-center justify-content-between mb-4">
        <Button className="mt-auto" onClick={authorize}>
          {localeStore.t('t2_foodics_auth')}
        </Button>
        <div className="d-flex align-items-center justify-content-between mr-4">
          {/* <div className='foodics-authorization-form__link cursor-pointer mr-6'>*/}
          {/*  {localeStore.t('pos_log1')}*/}
          {/* </div>*/}
          {/* <div className='foodics-authorization-form__link cursor-pointer'>*/}
          {/*  {localeStore.t('pos_log2')}*/}
          {/* </div>*/}
        </div>
      </div>
    </div>
  );
};

export default FoodicsAuthorizationForm;
